import { Box, Stack, Heading, Text } from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import RollingLine from "../../common/RollingLine";
import RollingLineReverse from "../../common/RollingLineReverse";

export default function UtilityRollingGrpc(props) {
  if (props.inverse) {
    return (
      <>
        <Stack
          as={"div"}
          backgroundColor={"#111"}
          height={"64px"}
          marginBottom={"-35px"}
          width={"100vw"}
        ></Stack>
        <Stack
          as={"div"}
          backgroundColor={"brand.red"}
          transform={"rotate(2deg)"}
          marginTop={"-36px"}
          zIndex={4}
          paddingTop={"10px"}
          width={"103vw"}
          marginLeft={"-8px"}
        >
          <RollingLineReverse />
          <Stack
            as={"div"}
            width={{ base: "103vw", md: "101vw" }}
            marginLeft={"-4px"}
            marginBottom={"6px"}
          >
            <Box
              as={"div"}
              backgroundColor="brand.red"
              padding={"40px 0px 28px"}
            >
              <Box paddingBottom={{ base: "12px", md: "24px" }}>
                <Text
                  as={"div"}
                  textAlign={"center"}
                  fontSize={{ base: "xs", md: "md" }}
                  color={"#fff"}
                >
                  Supercharged Solana Data Streams
                </Text>
                <Heading
                  as={"h2"}
                  textAlign={"center"}
                  fontSize={{ base: "3xl", xl: "5xl" }}
                  mb={{ base: "0px" }}
                  color={"#fff"}
                >
                  gRPC Geyser use Cases
                </Heading>
              </Box>

              <Marquee>
                <Box as="div" className="rolling_each_text">
                  Copy-Trading Bots
                </Box>
                <Box as="div" className="rolling_each_text">
                  Telegram trading bots
                </Box>
                <Box as="div" className="rolling_each_text">
                  Memecoin Snipers
                </Box>
                <Box as="div" className="rolling_each_text">
                  Real-time Portfolio Trackers
                </Box>
                <Box as="div" className="rolling_each_text">
                  Indexing Data
                </Box>
                <Box as="div" className="rolling_each_text">
                  On-chain Analytics
                </Box>
                <Box as="div" className="rolling_each_text">
                  Copy-Trading Bots
                </Box>
                <Box as="div" className="rolling_each_text">
                  Telegram trading bots
                </Box>
                <Box as="div" className="rolling_each_text">
                  Memecoin Snipers
                </Box>
                <Box as="div" className="rolling_each_text">
                  Real-time Portfolio Trackers
                </Box>
                <Box as="div" className="rolling_each_text">
                  Indexing Data
                </Box>
                <Box as="div" className="rolling_each_text">
                  On-chain Analytics
                </Box>
                <Box as="div" className="rolling_each_text">
                  Copy-Trading Bots
                </Box>
                <Box as="div" className="rolling_each_text">
                  Telegram trading bots
                </Box>
                <Box as="div" className="rolling_each_text">
                  Memecoin Snipers
                </Box>
                <Box as="div" className="rolling_each_text">
                  Real-time Portfolio Trackers
                </Box>
                <Box as="div" className="rolling_each_text">
                  Indexing Data
                </Box>
                <Box as="div" className="rolling_each_text">
                  On-chain Analytics
                </Box>
                
              </Marquee>
            </Box>
          </Stack>
          <RollingLineReverse />
        </Stack>
        <Stack
          as={"div"}
          backgroundColor={"#111"}
          height={"64px"}
          marginTop={"-35px"}
          width={"100vw"}
        ></Stack>
      </>
    );
  }
  return (
    <>
      <Stack
        as={"div"}
        backgroundColor={"#111"}
        transform={"rotate(-2deg)"}
        marginTop={"-36px"}
        zIndex={4}
      >
        <RollingLine />
        <Stack
          as={"div"}
          width={{ base: "103vw", md: "101vw" }}
          marginLeft={"-4px"}
          marginBottom={"6px"}
        >
          <Box as={"div"} backgroundColor="brand.red" padding={"40px 0px 28px"}>
            <Box paddingBottom={{ base: "12px", md: "24px" }}>
              <Text
                as={"div"}
                textAlign={"center"}
                fontSize={{ base: "xs", md: "md" }}
                color={"#fff"}
              >
                Build Faster and Smarter
              </Text>
              <Heading
                as={"h2"}
                textAlign={"center"}
                fontSize={{ base: "3xl", xl: "5xl" }}
                mb={{ base: "0px" }}
                color={"#fff"}
              >
                Complete Development Suite
              </Heading>
            </Box>

            <Marquee>
              <Box as="div" className="rolling_each_text">
                Low-Latency Streaming
              </Box>
              <Box as="div" className="rolling_each_text">
                Callbacks
              </Box>
              <Box as="div" className="rolling_each_text">
                Jup API
              </Box>
              <Box as="div" className="rolling_each_text">
                High-Speed RPCs
              </Box>
              <Box as="div" className="rolling_each_text">
                gRPC Streams
              </Box>
              <Box as="div" className="rolling_each_text">
                Parsed Transactions
              </Box>
              <Box as="div" className="rolling_each_text">
                Dedicated Nodes
              </Box>

              <Box as="div" className="rolling_each_text">
                Low-Latency Streaming
              </Box>
              <Box as="div" className="rolling_each_text">
                Callbacks
              </Box>
              <Box as="div" className="rolling_each_text">
                Jup API
              </Box>
              <Box as="div" className="rolling_each_text">
                High-Speed RPCs
              </Box>
              <Box as="div" className="rolling_each_text">
                gRPC Streams
              </Box>
              <Box as="div" className="rolling_each_text">
                Parsed Transactions
              </Box>
              <Box as="div" className="rolling_each_text">
                Dedicated Nodes
              </Box>
            </Marquee>
          </Box>
        </Stack>
        <RollingLine />
      </Stack>
      <Stack
        as={"div"}
        backgroundColor={"#111"}
        height={"64px"}
        marginTop={"-35px"}
        width={"100vw"}
      ></Stack>
    </>
  );
}
